import gql from 'graphql-tag';

export default gql`
  fragment UserRecipeFragment on UserRecipe {
    userRecipeId
    recipeId
    notes
    tags {
      recipeTagId
      name
      slug
      updatedAt
      public
    }
  }
`;
